'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/CollectedForms';
const INTIAL_STATE = new Record({
  forms: new ImmutableMap(),
  subscriptions: new ImmutableMap(),
  requestState: RequestStates.NOT_REQUESTED,
  subscriptionsRequestState: RequestStates.NOT_REQUESTED,
  renameRequestState: RequestStates.NOT_REQUESTED
})();
function receiveCollectedForm(state, form) {
  return state.set('forms', state.get('forms').set(form.formGuid, form));
}
function receiveSubscriptions(state, subscriptions, formGuid) {
  return state.set('subscriptions', state.get('subscriptions').set(formGuid, subscriptions));
}
function setRequestState(state, newRequestState) {
  return state.set('requestState', newRequestState);
}
function setSubscriptionRequestState(state, newRequestState) {
  return state.set('subscriptionsRequestState', newRequestState);
}
export function collectedForms(state = INTIAL_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_COLLECTED_FORM:
    case Actions.REQUEST_CONVERT_FORM:
      return setRequestState(state, RequestStates.REQUESTED);
    case Actions.REQUEST_SUBSCRIPTIONS:
      return setSubscriptionRequestState(state, RequestStates.REQUESTED);
    case Actions.RECEIVE_COLLECTED_FORM:
      return receiveCollectedForm(state, action.form);
    case Actions.SUCCEEDED_COLLECTED_FORM:
    case Actions.SUCCEEDED_CONVERT_FORM:
      return setRequestState(state, RequestStates.SUCCEEDED);
    case Actions.FAILED_COLLECTED_FORM:
    case Actions.FAILED_CONVERT_FORM:
      return setRequestState(state, RequestStates.FAILED);
    case Actions.SUCCEEDED_SUBSCRIPTIONS:
      return setSubscriptionRequestState(state, RequestStates.SUCCEEDED);
    case Actions.FAILED_SUBSCRIPTIONS:
      return setSubscriptionRequestState(state, RequestStates.FAILED);
    case Actions.RECEIVE_SUBSCRIPTIONS:
      return receiveSubscriptions(state, action.subscriptions, action.guid);
    case Actions.RESET_REQUEST_STATE:
      return setRequestState(state, RequestStates.NOT_REQUESTED);
    default:
      return state;
  }
}